// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1RvZ_","label":"Section_label__2V9_W","contentWrap":"Section_contentWrap__hS6Yx","footer":"Section_footer__1Qigp","footerInner":"Section_footerInner__HUXEv"};